import Api from '@/services/Api';

export default {
  updateCoD4() {
    return Api().get('q3query');
  },
  updateCSGO() {
    return Api().get('csgoquery');
  },
};
